import { render } from "./InfoModule.vue?vue&type=template&id=3978fb0a"
import script from "./InfoModule.vue?vue&type=script&lang=js"
export * from "./InfoModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__